<template>
  <div class="index-bg01">
    <div class="index-bg02">
      <div class="index-main">
        <div class="title" v-bind:class="{ handan: cityName=='邯郸市中心医院' }">{{ cityName }}急救中心管理驾驶舱</div>
        <div class="time">
          <img src="~@/assets/img/time.png" alt="">
          <span class="span1">{{ timeStr1 }}</span>
          <span class="span2">{{ timeStr2 }}</span>
        </div>
        <div class="index-content">
            <div class="index-content-left">
              <template v-if="!focusFlg" >
                <dt-car-map :city-id="cityId"></dt-car-map>
              </template>

              <template v-else>
                <div class="index-content-left-combo">
                  <!--上部分的视频监控-->
                  <div class="video-focus">
                    <div class="video-focus-item">
                      <div class="video-focus-info">{{ staticCarNo }}</div>
                      <svg-icon icon-class="close" class-name="video-focus-close" @click="videoFocusCloseHandler"></svg-icon>
                      <iframe class="video-focus-iframe" :src="staticVideoUrl"  :id="staticFrameId"></iframe>
                    </div>
                  </div>
                  <!--下部分的地图模块-->
                  <dt-car-map :city-id="cityId" class="map-focus"></dt-car-map>
                </div>
              </template>
            </div>
            <div class="index-content-right" :class="{ 'index-content-right__small': !isLarge }">
              <template v-for="(item) in videoList">
                <div class="item" :key="item.frameId"  :class="{ 'item__large': isLarge }">
                  <template v-if="!(item.videoUrl!=null && item.videoUrl!='')">
                     <div class="no-video"></div>
                  </template>

                  <template v-else>
                    <div class="video-info">{{ item.carNo }}</div>
                    <div class="iframe-container">
                      <div class="iframe-wrapper" style="aspect-ratio: 4 / 3; overflow: hidden;">
                        <iframe style="width: 100%; height: 100%; max-width: 100%; max-height: 100%; border-radius: 6px;" :src="item.videoUrl" v-if="item.frameId!=null && item.videoUrl!=null && item.videoUrl!=''"  :id="item.frameId">
                        </iframe>
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import DtCarMap from 'views/components/DtCarMap';
import { encode, decode } from 'js-base64';
import {
  isCarNo, transCarNoToEn, transEnToCarNo, getCityName,
} from '@/utils/dataUtil';

export default {
  components: {
    DtCarMap,

  },
  data() {
    return {
      liList: ['日', '月'],
      timeStr1: '',
      timeStr2: '',
      // hospitalCode: '0H15002', // 0H1B002
      timer: null,
      dataTimer: null,
      cityName: '武汉市',
      // 左侧是否默认展开
      focusFlg: false,
      videoUrl: '',
      srsHostUrl: 'https://srs.whmhyl.cn/xgrtcVideo',
      srsWebrtcHost: 'srs.whmhyl.cn:8443',
      // srsHostUrl: 'https://127.0.0.1:9998/html/srs-xgrtc-video.html',
      staticCarNo: '',
      staticFrameId: '',
      staticVideoUrl: '',
      videoList: [],
      isLarge: false,
      // 170：黄石， 169：武汉
      cityId: 170,
    };
  },
  created() {
    // 这种格式能获取: http://127.0.0.1:7001/#/ssoAuth?code=VHUHsF/hLJiA9KpvRB6%2BN0ASPm7sgosWPjR7WmOWlvukpSGQPSgkTO4xleZOWc0W&productCode=1
    console.log('query', this.$route.query);
    // 这种格式能获取: http://127.0.0.1:7001/?code=VHUHsF/hLJiA9KpvRB6%2BN0ASPm7sgosWPjR7WmOWlvukpSGQPSgkTO4xleZOWc0W&productCode=1#/ssoAuth
    const search = new URLSearchParams(window.location.search);
    console.log('search', search);
    if (search.get('cityId') != null && search.get('cityId') != '') {
      this.cityId = +search.get('cityId');
      let cityNameOri = getCityName(this.cityId);
      if (cityNameOri === '邯郸') {
        cityNameOri = '邯郸市中心医院';
      }
      this.cityName = cityNameOri || '未知类型';
    }
    console.log('cityId', this.cityId);
  },
  mounted() {
    const { query } = this.$route;
    // this.hospitalCode = query.hospitalCode || '0H15002';
    this.getAllCarCameras();
    this.getNowTime();

    // this.dataTimer = setInterval(() => {
    //   this.getAllCarCameras();
    // }, 30 * 60 * 1000);
    //
    this.timer = setInterval(() => {
      this.getNowTime();
    }, 1000);

    // 监听窗口发生变化，resize组件
    window.addEventListener('message', this.handleChildFrameEvent, false);
    // 通过hook监听组件销毁钩子函数，并取消监听事件
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('message', this.handleChildFrameEvent);
    });
  },

  destroyed() {
    clearInterval(this.dataTimer);
    clearInterval(this.timer);
  },
  methods: {

    /**
     * 关闭左边视频播放窗口
     */
    videoFocusCloseHandler() {
      this.focusFlg = false;
    },

    /**
     * 构建iframe窗口id用于识别定位
     *
     * 主要是由于中文不好作为id首字母
     * @param carNo
     * @returns {string}
     */
    buildCarVideoFrameId(carNo, playParam) {
      let frameId = transCarNoToEn(carNo);
      if (playParam) {
        frameId += (playParam.no || 'default');
      }
      return frameId;
    },

    /**
     * 实际转换
     *
     * @param code
     * @param no
     * @param type
     * @param host
     * @param frameId
     * @param controlFlg
     * @param objectFit
     * @param extContent
     * @returns {string}
     */
    convertUrl({
      code, no, type, host, frameId, controlFlg, objectFit, extContent,
    }) {
      let { srsHostUrl } = this;

      let str = `${srsHostUrl}?t=${new Date().getTime()}&p=${encode(`code=${code}&no=${no}&type=${type}&host=${host}&frameId=${frameId}&controlFlg=${controlFlg}&objectFit=${objectFit}&extContent=${extContent}`)}`;
      console.log(`convertUrl:${str}`);
      return str;
    },

    /**
     * 构造播放url地址
     * 参数不能有中文，会有问题
     *
     * code:房间号
     * no:当前用户标识
     * type: 2为接收端，1为主动发送方
     * host: srs服务器地址，当前固定
     * base64(code=0H1B002&no=B9BFB0&type=2&host=srs.whmhyl.cn:8443)
     *
     * 示例地址："https://srs.whmhyl.cn/xgrtcVideo?p=Y29kZT0wSDFCMDAyJm5vPUI5QkZCMCZ0eXBlPTImaG9zdD1zcnMud2htaHlsLmNuOjg0NDM=",
     * 示例地址："https://127.0.0.1:9998/html/srs-xgrtc-video.html?p=Y29kZT0wSDFCMDAyJm5vPUI5QkZCMCZ0eXBlPTImaG9zdD1zcnMud2htaHlsLmNuOjg0NDM=",
     * @param urlParam
     * @param playParam
     */
    buildVideoUrl(urlParam, playParam) {
      let { carNo, playParams, hospitalName } = urlParam;
      console.warn(`---当前医院名称：${hospitalName}`);

      // TODO 需要根据医院名称来判断是否使用自定义srs域名
      if (hospitalName === 'TODO') {
        this.srsWebrtcHost = 'srs.whmhyl.cn:8443';
        this.srsHostUrl = 'https://srs.whmhyl.cn/xgrtcVideo';
      }
      const p = {
        // 会主动在no参数前面加REMOTE_
        type: '2',
        host: this.srsWebrtcHost,
        controlFlg: 'off',
        /**
         * 外部控制视频填充样式
         * fill：视频将被拉伸以填充整个容器，可能会导致视频变形。
         * contain：视频将被缩放以适应容器，保持其宽高比例，可能会留有空白区域。
         * cover：视频将被缩放以填充整个容器，保持其宽高比例，可能会被裁剪。
         * none：视频将按原始尺寸显示，可能会超出容器。
         * scale-down：视频将按原始尺寸显示，或者根据需要缩放以适应容器，保持其宽高比例。
         */
        objectFit: 'contain',
      };

      const frameId = this.buildCarVideoFrameId(carNo, playParam);
      // 实际用于显示用的
      const extContent = transCarNoToEn(carNo);
      // playParam
      // [{ type: 1, code: '0H1B002', no: 'chaosheng' },
      // { type: 5, code: '0H1B002', no: 'jianhu' },
      // { type: 3, code: '0H1B002', no: 'inner' },
      // { "type": 7, "code": "0H1B002", "no": "inner2" },
      // { "type": 8, "code": "0H1B002", "no": "inner3"}
      // ];
      // 查找车内视频
      // eslint-disable-next-line eqeqeq
      let innerPlayParam = playParams.find((t) => (t.type == 3 || t.type == 7 || t.type == 8));
      if (innerPlayParam == null) {
        return null;
      }
      const { code, no } = innerPlayParam;
      let room = code;
      if (isCarNo(code)) {
        room = transCarNoToEn(code);
      }
      return this.convertUrl({
        ...p, 'code': room, no, frameId, extContent,
      });
    },

    /**
     * 网页全屏模式控制
     */
    goFullscreen(id) {
      var iframe = document.getElementById(id);
      if (iframe.requestFullscreen) {
        iframe.requestFullscreen();
      } else if (iframe.mozRequestFullScreen) { /* Firefox */
        iframe.mozRequestFullScreen();
      } else if (iframe.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        iframe.webkitRequestFullscreen();
      } else if (iframe.msRequestFullscreen) { /* IE/Edge */
        iframe.msRequestFullscreen();
      }
    },

    handleChildFrameEvent(event) {
      let self = this;
      console.log(event);
      function getParamsObjectFromUrl(url) {
        const searchParams = new URLSearchParams(decode(url.searchParams.get('p')));
        return Object.fromEntries(searchParams.entries());
      }

      try {
        if (typeof event.data === 'string' && event.data != '' && !event.data.startsWith('webpack')) {
          let frameUrl = event.data;
          const url = new URL(frameUrl);
          const paramsObject = getParamsObjectFromUrl(url);
          // childFrameInfo:
          // {"code":"0H1B002","no":"B9BFB0","type":"2","host":"srs.whmhyl.cn:8443","frameId":"video_1678428835712","controlFlg":"off"}
          console.log(`childFrameInfo:${JSON.stringify(paramsObject)}`);

          let focusFrameIdPrefix = 'focus_';
          if (paramsObject.frameId.startsWith(focusFrameIdPrefix)) {
            if (!document.fullscreenElement) {
              self.goFullscreen(paramsObject.frameId);
            } else if (document.exitFullscreen) {
              document.exitFullscreen();
            }
          } else {
            // 点击右边的视频，需要同步在左边显示
            paramsObject.frameId = focusFrameIdPrefix + paramsObject.frameId;
            let newP = [];
            Object.entries(paramsObject).forEach(([prop, value]) => {
              console.log(`${prop}: ${value}`);
              newP.push(`${prop}=${value}`);
            });
            const newUrl = frameUrl.replace(/p=[^&]*/, `p=${encode(newP.join('&'))}`);
            console.log('newUrl:', newUrl);
            this.staticCarNo = transEnToCarNo(paramsObject.extContent);
            this.focusFlg = true;
            this.staticVideoUrl = newUrl;
            this.staticFrameId = paramsObject.frameId;
          }
        } else {
          console.log('非业务数据，不处理');
        }
      } catch (error) {
        console.error('Failed to handle child frame event:', error);
      }
    },

    changeHandle(index) {
      this.current = index;
    },
    getNowTime() {
      this.timeStr2 = moment().format('YYYY-MM-DD');
      this.timeStr1 = moment().format('HH:mm:ss');
    },

    getAllCarCameras() {
      console.log('getAllCarCamera');
      let self = this;
      this.$axios({
        url: `/api/apvehicle/car/position/allCarCamera/${self.cityId}`,
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => {
        const { data, status } = res;
        let camerasDataArray = [];
        // eslint-disable-next-line no-empty
        if (status == 200 && data && data.msg == 201) {
          let carCameras = data.respData;
          // eslint-disable-next-line no-restricted-syntax
          for (let item of carCameras) {
            let {
              deviceName, deviceModel, deviceNo, carNo, playParam, hospitalName,
            } = item;
            camerasDataArray.push({
              deviceName,
              deviceModel,
              deviceNo,
              hospitalName,
              carNo,
              playParam,
              frameId: null,
              videoUrl: null,
            });
          }
          // let list = [{
          //   carNo: '鄂A00001',
          //   playParam: '',
          //   frameId: null,
          //   videoUrl: null,
          // },
          // {
          //   carNo: '鄂A00002',
          //   playParam: '',
          //   frameId: null,
          //   videoUrl: null,
          // },
          // {
          //   carNo: '鄂A00003',
          //   playParam: '',
          //   frameId: null,
          //   videoUrl: null,
          // }];
          self.buildVideosData(camerasDataArray);
        } else {
          console.log('系统错误');
        }
      });
    },

    /**
     * 构造视频数据格式
     *
     * @param list
     */
    buildVideosData(list) {
      console.log('---buildVideosData---,list:', list);
      let self = this;
      let videoListArray = [];
      // eslint-disable-next-line no-unused-expressions
      (list.length > 0) && list.forEach((item, index) => {
        // code: 房间号， no:参与用户
        // playParam
        // [{ type: 1, code: '0H1B002', no: 'chaosheng' },
        // { type: 5, code: '0H1B002', no: 'jianhu' },
        // { type: 3, code: '0H1B002', no: 'inner' },
        // { "type": 7, "code": "0H1B002", "no": "inner2" },
        // { "type": 8, "code": "0H1B002", "no": "inner3"}
        // ];
        const playParams = [];
        let playParam = {};
        if (item.playParam != '' && item.playParam != null) {
          playParam = JSON.parse(item.playParam);
          playParams.push(JSON.parse(item.playParam));
        }
        console.log('playParams:', playParams);
        const frameId = this.buildCarVideoFrameId(item.carNo, playParam);

        const videoUrl = this.buildVideoUrl({ carNo: item.carNo, playParams, hospitalName: item.hospitalName }, playParam);
        console.log('%c%s', 'color:blue', `待播放url:${videoUrl}`);
        if (videoUrl != null && videoUrl != '') {
          videoListArray.push(item);
          self.$set(item, 'frameId', frameId);
          self.$set(item, 'videoUrl', videoUrl);
        } else {
          console.error('当前车辆未找到播放参数信息,车辆信息：', item);
        }
      });
      const len = videoListArray.length;
      if (len < 12) {
        for (let i = 0; i < (12 - len); i++) {
          let o = {
            carNo: null,
            playParam: '',
            // 待填充的值不能一样
            frameId: `empty_${i}`,
            videoUrl: null,
          };
          videoListArray.push(o);
        }
      }

      // TODO 用于模拟多个视频的场景
      // let newArr = Array.from({ length: 20 }).fill(videoListArray[0]);
      // console.log('newArr:', newArr);
      // this.isLarge = true;
      // this.videoList = newArr;

      this.videoList = Object.assign([], videoListArray);
      console.log('videoList:', this.videoList);
    },
  },
};
</script>
<style>
::-webkit-scrollbar {
  width: 1px; /* 设置滚动条的宽度 */
}

::-webkit-scrollbar-thumb {
  background-color: #ccc; /* 设置滚动条滑块的颜色 */
  border-radius: 5px; /* 设置滚动条滑块的圆角 */
}

/* firefox:设置滚动条的宽度和颜色 */
.index-content-right {
  scrollbar-width: thin;
  scrollbar-color: #ccc #f1f1f1;
}

iframe {
  border: none;
  outline: none;
}

</style>
<style lang="scss" scoped>
.index-bg01{
  width: 100%;
  height: 100%;
  background: url('~@/assets/img/img_bg01.png');
  background-size: 100% 100%;

  .index-bg02{
    width: 100%;
    height: 100%;
    background: url('~@/assets/img/img_bg02.png');
    background-size: 100% 100%;

    .index-main{
      height: 100%;
      padding: vh(14) vw(60) vh(60);
      display: flex;
      flex-direction: column;

      .title{
        font-size: rf(40);
        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
        text-align: center;
        font-weight: bold;
        line-height: vh(47);
        background: linear-gradient(180deg, #FFFFFF 0%, rgba(120,198,255,0.4) 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        &.handan{
          font-size: 1.7vw;
        }
      }

      .time{
        height: vh(24);
        display: flex;
        align-items: center;
        img{
          height: 100%;
        }
        .span1{
          font-size: rf(20);
          color: #B5DBFF;
          margin: 0 vw(8);
          font-weight: 500;
        }
        .span2{
          font-size: rf(16);
          color: #B5DBFF;
          font-weight: 400;
        }
      }

      .index-content{
        margin-top: vh(26);
        height: vh(900);
        overflow-y: hidden;
        flex: 1;
        display: flex;
        justify-content: space-between;

        .index-content-left{
          flex: 1 1 60%;
          display: flex;

          .index-content-left-combo{
            flex:1;
            /*列式排列*/
            //display: flex;
            //flex-direction: column;
            //justify-content: center;
            //align-items: center;
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: 1fr 1fr;
            grid-gap: 2vh;

            .video-focus{
              //flex: 1 1 50%;
              min-height: 0;
              width: 100%;
              display: flex;
              overflow: hidden;
              position: relative;

              .video-focus-item{
                //position: relative;
                border-radius: 6px;
                flex:1;
                overflow: hidden;
                /*这个属性影响子窗体的aspect-ratio属性*/
                display: flex;

                //display: grid;
                //grid-template-columns: 1fr;
                //grid-template-rows: 1fr;

                /*绝对定位*/
                .video-focus-info{
                  position: absolute;
                  left: 1%;
                  top: 1%;
                  color: #0649d3;
                  font-size: .8vw;
                }
                /*绝对定位*/
                .video-focus-close {
                  position: absolute;
                  right: 1%;
                  top: 1%;
                  width: 2em;
                  height: 2em;
                  z-index: 99;
                }

                .video-focus-iframe{
                  //width: 100%;
                  /*这个属性影响子窗体的aspect-ratio属性*/
                  //height: 100%;
                  //grid-row: 1;
                  //grid-column: 1;
                  //aspect-ratio: 4/3;
                  flex: 1;
                }
              }
            }

            .map-focus{
              //flex: 1 1 50%;
              min-height: 0;
            }

          }

        }

        .index-content-right{
          padding-left: 2vh;
          padding-right: vw(5);
          flex: 1 1 40%;
          max-height: 100%;
          overflow-y: auto;
          min-height: 0;
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(calc(33% - 4vh), 1fr));
          grid-gap: 2vh;

          //视频数量少时，设置为四行布局
          &.index-content-right__small{
            grid-template-rows: repeat(auto-fit, minmax(calc(25% - 12vh), 1fr));
          }

          .item{
            position: relative;
            border-radius: 6px;
            display: flex;
            align-items: center;
            overflow: hidden;
            background-color: #08185d;

            //视频数量多时，限制每个视频的最小高度
            &.item__large{
              min-height: 200px;
            }

            .video-info{
              position: absolute;
              left:1%;
              top:1%;
              color: #7e97c9;
              font-size:.8vw;
              z-index:600;
            }

            .no-video {
              border-radius: 6px;
              width: 100%;
              height: 98%;
              background-image: url("~@/assets/img/no_video.png");
              background-size: 50%;
              background-position: center;
              background-color: #7280a9;
              background-repeat: no-repeat;
            }

            .iframe-container{
              width: 100%;
              height: 100%;
              display: flex;
              .iframe-wrapper {
                position: relative;
                margin-top:auto;
                flex:1;

                iframe {
                  position: absolute;
                  top: 0;
                  left: 0;
                }
              }
            }
          }
        }

      }
    }
  }
}

</style>
